export const NAME_VALIDATION_REGEX =
  /^[^/][a-zA-Z0-9~@#$^*()_+=[\]{}|\\,//.?:-]*$/;
